import { ANSWER } from './constants';

const homePage = {
  enabled: process.env.REACT_APP_HOMEPAGE_DISABLED !== ANSWER.yes,
  showWelcomeModal: process.env.REACT_APP_SHOW_WELCOME_MODAL === ANSWER.yes
};
const automation = {
  enabled: process.env.REACT_APP_AUTOMATION_DISABLED !== ANSWER.yes
};
const teams = {
  enabled: process.env.REACT_APP_TEAMS_ENABLED === ANSWER.yes
};
const publicLogin = {
  enabled: process.env.REACT_APP_PUBLIC_LOGIN_ENABLED === ANSWER.yes,
  isBackendRedirect: process.env.REACT_APP_IS_BACKEND_REDIRECT === ANSWER.yes,
  register: process.env.REACT_APP_REGISTER === ANSWER.yes
};
const recognition = {
  enabled: process.env.REACT_APP_RECOGNITION_DISABLED !== ANSWER.yes
};
const salesforce = {
  enabled: process.env.REACT_APP_SALESFORCE_DISABLED !== ANSWER.yes
};
const paymentMethods = {
  enabled: ANSWER.yes
};
const underMaintenance = {
  enabled: process.env.REACT_APP_UNDER_MAINTENANCE === ANSWER.yes
};

const advanceSettingsEnabled = process.env.REACT_APP_ADVANCE_SETTINGS_DISABLED !== ANSWER.yes;
const advanceSettings = {
  enabled: advanceSettingsEnabled,
  charityEnabled: advanceSettingsEnabled && process.env.REACT_APP_CHARITY_DISABLED !== ANSWER.yes,
  onlyCollectAddressEnabled:
    advanceSettingsEnabled && process.env.REACT_APP_ONLY_COLLECT_ADDRESS_DISABLED !== ANSWER.yes,
  scratchEffectEnabled:
    advanceSettingsEnabled && process.env.REACT_APP_SCRATCH_EFFECT_DISABLED !== ANSWER.yes
};

export {
  advanceSettings,
  automation,
  homePage,
  paymentMethods,
  publicLogin,
  recognition,
  salesforce,
  teams,
  underMaintenance
};
